import { getDefaultOptions } from '@rideiq/api/services/Reports';
import { DefaultSelectedFilters, StaticFilters } from '@rideiq/reports/types';
import { useQuery } from '@tanstack/react-query';

export const REPORTS_DEFAULT_OPTIONS_QUERY_KEY = 'reportsDefaultOptions';

export const useReportsQuery = () => {
  const { data, isFetching, isLoadingError, refetch } = useQuery({
    queryKey: [REPORTS_DEFAULT_OPTIONS_QUERY_KEY],
    queryFn: async ({ signal }) => {
      const response = await getDefaultOptions(signal);

      if (response.type === 'error') {
        throw new Error(response.error.errors[0] ?? 'Failed to load default report options');
      }

      return response.data;
    },
  });

  return {
    defaultSelectedFilters: (data?.defaultSelectedFilters ?? null) as Nullable<DefaultSelectedFilters>,
    staticFilters: (data?.staticFilters ?? null) as Nullable<StaticFilters>,
    isFetchingDefaultOptions: isFetching,
    isLoadingErrorDefaultOptions: isLoadingError,
    refetchDefaultOptions: refetch,
  };
};
